import { Component, OnInit, Input } from '@angular/core';
import { RequestStatus, ComponentTypes } from '@app/shared/types';
import { Subject } from 'rxjs';
import { UtilsService } from '@app/core/services';
import { AccountStatus } from '@app/views/pages/my-accounts/types/account-status';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-status',
    imports: [
        CommonModule,
        TranslateModule
    ],
    templateUrl: './request-status.component.html',
    styleUrls: ['./request-status.component.scss']
})
export class RequestStatusComponent implements OnInit {
	unsubscribeAll$ = new Subject<void>();

  @Input() title: string;
  @Input() text: string;
  @Input() text2: string;
  @Input() requestStatusType: RequestStatus;
  @Input() accountStatusType: AccountStatus;
  @Input() isWating: boolean;
  @Input() removeIcon: boolean;
  @Input() componentType: ComponentTypes;

  isLoading = false;

  // types
  requestStatusTypes = RequestStatus;
  componentTypes = ComponentTypes;
  accountStatus = AccountStatus;

  constructor(
    private utilsService: UtilsService
  ) {}

  ngOnInit() {
    this.manageStatus();
  }

  manageStatus(): void {
    if (!this.utilsService.isRequestCompleted(this.requestStatusType)) {
      this.isWating = true;
    }

  }

}
